import PropTypes from "prop-types";
import { FaExternalLinkAlt } from "react-icons/fa";
import './style.scss';

const ProjectCard = (props) => {
  return (
    <div className="project-card">
      <div className="project-title">
        <h2>{props.nom}</h2>
      </div> 
      <div className="project-img">
        <img src={props.img} alt={props.nom} />
      </div>
   
      <div className="project-description">
        <p>{props.description}</p>
      </div>
      
      <div className="project-links">
        <ul className="tech">
          {props.technologies.map((technologie, techIndex) => (
            <li key={techIndex}>{technologie}</li>
          ))}
        </ul>
        <a href={props.lien} className="external-link">
          <FaExternalLinkAlt />
        </a>
      </div>
    </div>
  );
};

ProjectCard.propTypes = {
  nom: PropTypes.string.isRequired,
  technologie: PropTypes.arrayOf(PropTypes.string).isRequired,
  img: PropTypes.string.isRequired,
  lien: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default ProjectCard;
